/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Inbox_S1Inputs */

const en_tut_inbox_s1 = /** @type {(inputs: Tut_Inbox_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Inbox** at the top of the left menu, or press \`G\` then \`I\`.`)
};

const id_tut_inbox_s1 = /** @type {(inputs: Tut_Inbox_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka **Inbox** di menu paling atas, atau tekan \`G\` lalu \`I\`.`)
};

/**
* | output |
* | --- |
* | "Open **Inbox** at the top of the left menu, or press `G` then `I`." |
*
* @param {Tut_Inbox_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_inbox_s1 = /** @type {((inputs?: Tut_Inbox_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Inbox_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_inbox_s1(inputs)
	return en_tut_inbox_s1(inputs)
});